import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsCsmChatRoute: InvariantJiraRoute = {
	name: 'products-csm-chat',
	path: '/jira/settings/products/customerservice/chat',
	exact: true,
};
